import {ISVG} from "../../common/Logo/Logo";

export interface IShape1Props extends Pick<ISVG, "fill"> {}

export const Shape1 = ({ fill }: IShape1Props) => {
    const _fill = fill ?? "white;";

    return (
        <svg
            width="43"
            height="114"
            viewBox="0 0 43 114"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M-7.8417 0.424391C3.81438 1.39009 14.7647 5.66875 23.632 14.5445C33.3408 24.2626 42.1689 36.3561 42.9363 51.2507C43.7396 66.8409 36.8486 81.292 27.6562 92.6501C18.157 104.387 5.99452 114.323 -7.8417 113.992C-21.4815 113.666 -32.1494 102.099 -41.9144 90.9879C-51.8506 79.6822 -62.5459 67.4322 -62.9826 51.2507C-63.4284 34.7328 -55.2464 19.1779 -44.1291 8.93053C-34.0667 -0.344592 -20.6353 -0.635558 -7.8417 0.424391Z"
                fill={_fill}
            />
        </svg>
    );
};
